<template>
    <router-link class="o-logo" to="/">
        <svg class="o-logo__svg" xmlns="http://www.w3.org/2000/svg" width="160.482" height="33.003" viewBox="0 0 160.482 33.003">
            <path d="M17.457 12.258a8.691 8.691 0 00-6.2-2.342 11.417 11.417 0 00-8.151 3.073A11.455 11.455 0 000 21.327a11.755 11.755 0 003.139 8.587 11.042 11.042 0 008.006 2.99h.116a9.241 9.241 0 006.245-2.574l.166 1.96h5.946V10.414h-6.045zm-1.545 13.005a5.187 5.187 0 01-4.086 1.761 5.32 5.32 0 01-5.531-5.7 5.3 5.3 0 015.531-5.664c3.754 0 5.448 2.94 5.448 5.68a6.013 6.013 0 01-1.362 3.923z"/>
            <path d="M43.119 12.207a10.362 10.362 0 00-6.212-2.292c-6.86 0-11.112 4.368-11.112 11.411 0 6.827 4.518 11.411 11.245 11.411a8.372 8.372 0 006.245-2.425l.233 1.96h5.9V1.777h-6.3zm-5.747 14.6a5.217 5.217 0 01-5.282-5.5 5.138 5.138 0 015.282-5.448 5.311 5.311 0 015.415 5.448 5.275 5.275 0 01-5.415 5.5z"/>
            <path d="M69.046 12.207a10.362 10.362 0 00-6.212-2.292c-6.86 0-11.112 4.368-11.112 11.411 0 6.827 4.518 11.411 11.245 11.411a8.372 8.372 0 006.245-2.425l.233 1.96h5.9V1.777h-6.3v10.43zm-5.747 14.6a5.217 5.217 0 01-5.282-5.5 5.138 5.138 0 015.282-5.448 5.311 5.311 0 015.415 5.448 5.275 5.275 0 01-5.415 5.5z"/>
            <path d="M87.716 18.387c-3.305-.216-3.305-1.312-3.305-1.678 0-1.329 2.226-1.462 3.189-1.462a6.4 6.4 0 014.717 1.678l.448.432 3.621-4.269-.432-.382c-2.325-2.043-4.767-2.873-8.438-2.873-4.634 0-9.3 2.176-9.3 7.042 0 4.069 3.239 6.561 9.1 7.009 3.289.183 3.554.9 3.554 1.595a1.373 1.373 0 01-.465 1.013 3.739 3.739 0 01-2.674.88c-2.06-.033-5.315-1.146-6.71-2.691l-.5-.548-3.203 4.652.332.349c3.272 3.4 6.876 3.87 9.982 3.87 6.544 0 9.484-3.7 9.484-7.375.001-6.628-6.826-7.076-9.4-7.242z"/>
            <path d="M109.54 9.999A10.946 10.946 0 0098.262 21.36c0 6.694 4.651 11.361 11.328 11.361 6.694 0 11.361-4.667 11.361-11.361A11.016 11.016 0 00109.54 9.999zm.05 16.859c-3.471 0-5.033-2.757-5.033-5.5 0-2.674 1.578-5.531 5.033-5.531 3.156 0 5.033 2.807 5.033 5.531-.001 2.743-1.562 5.5-5.033 5.5z"/>
            <path d="M144.354 23.453v-7.076h5.743v-5.664h-5.7v-5.1h-6.3v5.1h-6.815V8.454a2.839 2.839 0 012.84-2.84h3.986V0h-4.966a8.513 8.513 0 00-4.185 1.063 7.36 7.36 0 00-2.923 3.073 9.941 9.941 0 00-1.047 4.684v1.893h-3.87v5.664h3.853v15.9h6.3v-15.9h6.843v7.607a9.85 9.85 0 001.046 4.651 7.238 7.238 0 002.907 3.04 8.386 8.386 0 004.152 1.063h3.879v-5.581h-2.92a2.821 2.821 0 01-2.824-2.824v-.88z"/>
            <path d="M157.111 27.157h-4.1v5.581h7.474v-2.209a3.374 3.374 0 00-3.374-3.372z" fill="#614192"/>
        </svg>
    </router-link>
</template>

<script>
    export default {
        name: 'AppLogo',
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    .o-logo {
        display: block;
        height: rem(21);
        width: rem(103);

        @include media-breakpoint-up(sm) {
            height: rem(26);
            width: rem(127);
        }

        @include media-breakpoint-up(lg) {
            height: rem(33);
            width: rem(160);
        }

        &__svg {
            @include square(inherit);
            pointer-events: none;
        }
    }
</style>
